import { render, staticRenderFns } from "./NewControls.vue?vue&type=template&id=9b7dc3ac&"
import script from "./NewControls.vue?vue&type=script&lang=js&"
export * from "./NewControls.vue?vue&type=script&lang=js&"
import style0 from "./NewControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports